import { useAuth0 } from '@auth0/auth0-react';
import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router';

import { LoginCard } from './components';
import { useGlobalStore } from '../../../hooks/useGlobalStore';
import { fetchCsrfTokenQueued } from '../../../utils/CsrfToken';
// import { SessionTimeoutManager } from '../../../services/SessionTimeoutManager';

import classes from './Auth0Login.module.css';

const LoginLoadingCard = (): JSX.Element => (
  <LoginCard className={classes.center}>
    <div className={classes.spinner} />
  </LoginCard>
);

const LoginErrorCard = (): JSX.Element => (
  <LoginCard className={classes.center}>
    <LoginCard.Logo />
    <LoginCard.Title>Oops!</LoginCard.Title>
    <LoginCard.Description>
      Something went wrong and we couldn&apos;t log you in. <br />
      You won&apos;t be able to continue right now - please reach out to our
      support team so we can help you get back in.
    </LoginCard.Description>
  </LoginCard>
);

const Auth0LoginCallback: React.FC = () => {
  const { isLoading, isAuthenticated, user } = useAuth0();
  const { loginUser } = useGlobalStore();
  const history = useHistory();
  const location = useLocation();
  const [hasLoginFailed, setHasLoginFailed] = useState(false);

  const urlParams = new URLSearchParams(location.search);
  const auth0ErrorCode = urlParams.get('error');

  useEffect(() => {
    const handleDjangoLogin = async (): Promise<void> => {
      try {
        // Ensure CSRF cookie is set before making the login request
        await fetchCsrfTokenQueued();

        const result = await loginUser();

        if (result.success) {
          // SessionTimeoutManager.start();
          history.push('/admin/employers');
        } else {
          setHasLoginFailed(true);
        }
      } catch (e: any) {
        setHasLoginFailed(true);
      }
    };

    if (auth0ErrorCode) {
      setHasLoginFailed(true);
      return;
    }

    if (!isLoading && isAuthenticated && user) {
      handleDjangoLogin();
    }
  }, [isLoading, isAuthenticated, user, history, location.search, loginUser, auth0ErrorCode]);

  return (
    <div className={classes.loginPageContainer}>
      {hasLoginFailed ? <LoginErrorCard /> : <LoginLoadingCard />}
    </div>
  );
};

export default Auth0LoginCallback;